import {BaseService} from "./base.service";

class SupplierOpticiansService extends BaseService {

    constructor() {
        super('api/opticians')
    }

}

export const supplieropticiansService = new SupplierOpticiansService();
